'use client';

import { useEffect } from 'react';
import { loadGTMOptimized, loadAmplitudeOptimized, loadGoogleAnalyticsOptimized } from '@/lib/performanceManager';

export const AnalyticsScripts = () => {
  useEffect(() => {
    // Load analytics with error handling to prevent unhandled rejections
    loadGTMOptimized().catch(() => {});
    loadGoogleAnalyticsOptimized().catch(() => {});
    loadAmplitudeOptimized().catch(() => {});
  }, []);

  return (
    <>
      {/* All analytics scripts are now loaded with ultra-aggressive optimization */}
      {/* Scripts load only after 10s or user interaction + 3s delay */}
    </>
  );
};
